import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";

class ModalWidget extends Component {
	state = {
		data: [],
		loaded: false,
		title: [],
		body: [],
		footer: [],
		show: false,
		size: "",
	};

	constructor(props) {
		super(props);

		this.close = this.close.bind(this);
	}

	componentDidMount() {
		this.setState({ data: this.props.data, loaded: true });
	}

	close() {
		this.setState({
			title: [],
			body: [],
			footer: [],
			show: false,
			size: "",
		});
	}

	render() {
		if (this.state.loaded) {
			return (
				<Modal
					className="mi-react-modal"
					show={this.state.show}
					centered={true}
					backdrop="static"
					onHide={this.close}
					size={this.state.size}>
					{/*<Modal.Header>*/}
					{/*  <Modal.Title className="mb-0 w-100 pb-0">*/}
					{/*    {this.state.title}*/}
					{/*  </Modal.Title>*/}
					{/*  <button*/}
					{/*    type="button"*/}
					{/*    className="close"*/}
					{/*    data-dismiss="modal"*/}
					{/*    aria-label="Close"*/}
					{/*    onClick={this.close}*/}
					{/*  >*/}
					{/*    <span aria-hidden="true" style={{ fontSize: "30px" }}>*/}
					{/*      &times;*/}
					{/*    </span>*/}
					{/*  </button>*/}
					{/*</Modal.Header>*/}
					<Modal.Body>{this.state.body}</Modal.Body>
					{/*<Modal.Footer>{this.state.footer}</Modal.Footer>*/}
				</Modal>
			);
		} else {
			return "";
		}
	}
}

export default ModalWidget;
